
import { mapGetters } from 'vuex'

export default {
  name: 'AlertInfo',

  computed: {
    ...mapGetters({
      isVisible: 'alert/infoIsVisible',
      alert: 'alert/getInfoMessage'
    })
  },
}
